<template>
  <div class="bind-card-view">
    <!-- <ph-tabs
      v-if="needTabs"
      v-model="type"
      :list="[{ name: '就诊卡包' }, { name: '手动添加' }]"
    /> -->
    <div class="inpatient-card-bind">
      <!-- <ListPage v-if="type === 0" :card-list="cardList" /> -->
      <EditPage :ftype="ftype" />
    </div>
  </div>
</template>

<script>
import EditPage from "./editpage";

export default {
  components: { EditPage },
  data() {
    return {
      type: -1,
      ftype: "1",
      cardList: [],
      needTabs: false
    };
  },
  created() {
    this.ftype = this.$route.query.ftype || "1";
    if (this.ftype === "1") {
      //this.loadData();
    } else {
      this.needTabs = false;
      this.type = 1;
    }
  },
  methods: {
    loadData() {
      this.$http
        .post(this.$http.api.USER_QRCODE_CARD, {
          functionType: "1"
        })
        .then(res => {
          if (res.flag == "0") {
            this.type = 1;
            this.needTabs = false;
          } else {
            this.type = 0;
            this.needTabs = true;
            this.loadCardList();
          }
        });
    },
    loadQrCardList() {
      this.$http
        .post(this.$api.CARDS_AVABLE_LIST_QRCODE, {
          functionType: "1"
        })
        .then(res => {
          this.cardQrList = res && res.card_list;
          this.familyCardList = res && res.family_list;
        });
    },
    loadCardList() {
      this.$http
        .post(this.$api.CARDS_AVABLE_LIST_HOSPITAL, {
          functionType: "1"
        })
        .then(res => {
          this.cardList = res;
          // this.loadQrCardList();
        });
    }
  }
};
</script>

<style lang="less" scoped>
.type-tabs {
  display: flex;
  justify-content: space-around;
  padding: 1.5rem 2rem;
  font-size: 0.94rem;
}
.inpatient-card-bind {
  height: calc(100% - 3.7rem);
  overflow: scroll;
}
</style>
